import React, { useEffect } from "react";
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from "../../../components/general/general-component/abstruct-component/AbstructVar";
import { AbstructLang } from "../../../components/general/general-component/abstruct-component/AbstructLang";
import { VariableTransactions } from "./VariableTransactions";
import { Form } from "../../../components/general/general-component/abstruct-component/AbstructForm";
import {
  getPageListTransaction,
  postTransaction,
} from "../../../store/Actions/ActionTransactions";
import { useSelectorCustom } from "../../../components/general/general-component/abstruct-component/useSelectorCustom";

function AddTransaction({
  open,
  setOpen,
  isAccount,
  isTransactionType,
  account_id,
  transaction_type,
}) {
  let { mode, dispatch, langLocal } = AbstructVar();
  const { translate } = AbstructLang();
  const { page_list_transaction, loadingPageListTransaction } =
    useSelectorCustom();
  const { state, setStateCustom, setLoad, setState } = VariableTransactions();
  const Submit = (e) => {
    e.preventDefault();
    dispatch(postTransaction(state, setLoad));
  };
  useEffect(() => {
    dispatch(getPageListTransaction());
  }, []);
  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setState((prevState) => ({
      ...prevState,
      account_id: !isAccount ? account_id : "",
      transaction_date: formattedDate,
      transaction_type: !isTransactionType ? transaction_type : "",
      transaction_type_name: page_list_transaction?.transaction_types?.label,
    }));
  }, [page_list_transaction]);
  const formFields = [
    isAccount && {
      name: "account_id",
      label: "account",
      type: "text",
      inputType: "one_select",
      iconType: "user",
      options: page_list_transaction?.accounts?.map((account) => ({
        value: account?.id,
        label: account?.name,
      })),
    },
    {
      name: "amount",
      label: "amount",
      type: "text",
      inputType: "text",
      iconType: "pencil",
    },
    {
      name: "transaction_date",
      label: "transaction_date",
      type: "text",
      inputType: "text",
      iconType: "pencil",
      disabled: true,
    },
    isTransactionType && {
      name: "transaction_type",
      label: "transaction_type",
      type: "text",
      inputType: "one_select",
      iconType: "user",
      options: page_list_transaction?.transaction_types?.map(
        (transaction_type) => ({
          value: transaction_type?.value,
          label: transaction_type?.label,
        })
      ),
    },
    {
      name: "description",
      label: "description",
      type: "text",
      inputType: "textArea",
      iconType: "pencil",
    },
  ];
  return (
    <RModal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      center
      classNames={{
        modal: `popupR`,
      }}
      focusTrapped={false}
      overlayOpacity={0.5}
    >
      <div
        className={`div_popup ${mode === "dark" ? "darkPopUp" : "lightPopUp"}`}
      >
        <div
          className={`div_title_popup ${
            mode === "dark" ? "darktoppopup" : "lighttoppopup"
          }`}
        >
          <p
            className={`title_popup ${
              mode === "dark" ? "darktext" : "lighttext"
            }`}
          >
            {translate("add_transaction")}
          </p>
        </div>
        <Form
          langLocal={langLocal}
          fields={formFields}
          handleSubmit={Submit}
          state={state}
          setStateCustom={setStateCustom}
          buttonLabel="add"
        />
      </div>
    </RModal>
  );
}

export default AddTransaction;
